import { useEffect } from 'react';
import { isProdBuild, isStagingBuild } from '../../i18n/environments';

const HubSpotTracking = () => {
  useEffect(() => {
    if (isProdBuild || isStagingBuild) {
      (window as any).hsConversationsSettings = { loadImmediately: false };
    }

    const script = document.createElement('script');
    script.src = 'https://js.hs-scripts.com/47424004.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      script.parentNode.removeChild(script);
    };
  }, []);

  return null;
};

export default HubSpotTracking;
